import { fileQueryKeys } from "@/shared/domain/files/hooks";

/**
 * Query keys for URDF-derived reads.
 *
 * Deliberately nested under the *file* key factory rather than rooted at a
 * namespace of their own: a file's visualization asset is derived from one
 * metadata key of the file's own record, so an invalidation of that record must
 * refresh it too. Keeping the nesting here — rather than adding a URDF entry to
 * `fileQueryKeys` — makes the dependency point urdf → files, never the reverse.
 */
export const urdfQueryKeys = {
  visualizationAsset: (fileId: string) =>
    [...fileQueryKeys.detail(fileId), "visualizationAsset"] as const,
};
